import { searchSystemsBrowse } from "../../../api/accounts.service";
import { useAccountTypeBrowse } from "../../../hooks/useAccountTypeBrowse";
import { SYSTEM_ACCOUNT_TYPE } from "./systems.constants";

export function useSystemsBrowse() {
  return useAccountTypeBrowse({
    accountType: SYSTEM_ACCOUNT_TYPE,
    searchBrowse: searchSystemsBrowse,
  });
}
